import React from 'react';

const parseDate = (dateString) => {
  if (!dateString) return null;
  const [day, month, year] = dateString.split('-'); // Adjusted to handle date strings without time parts
  return new Date(`${year}-${month}-${day}`);
};

const getStatus = (state, updatedDate, closeDate) => {
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0); // Set to start of today
  if (state === 'PIPELINE') {
    if (closeDate && parseDate(closeDate) < currentDate) {
      return { text: 'Expired', color: 'bg-gray-700' };
    }
  }
  switch (state) {
    case 'PENDING':
      return { text: 'Incomplete', color: 'bg-yellow-400' };
    case 'SAVED':
      return { text: 'Incomplete', color: 'bg-yellow-500' };
    case 'PIPELINE':
      if (updatedDate) {
        return { text: 'Updated', color: 'bg-blue-500' };
      }
      return { text: 'Pipeline', color: 'bg-cyan-500' };
    case 'WON':
      return { text: 'Won', color: 'bg-green-700' };
    case 'LOST':
      return { text: 'Lost', color: 'bg-red-500' };
    default:
      return { text: 'Unknown', color: 'bg-gray-500' };
  }
};

const ProposalStatus = ({ state, updatedDate, closeDate }) => {
  const { text, color } = getStatus(state, updatedDate, closeDate);

  return (
    <span
      className={`px-2 py-1 rounded text-white ${color} flex justify-center`}
    >
      {text}
    </span>
  );
};

export default ProposalStatus;
